import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


// export default {
//   inheritAttrs: false,
// };

import { defineComponent, computed, useAttrs } from "vue";
const __default__ = defineComponent({
  name: "VZButton",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// const databaseFormat = "YYYY-MM-DD";
const attrs = useAttrs();
const dynamicAttrs = computed(() => {
  const clonedAttrs = { ...attrs };
  // Check if attrs.style.defaultFonts is "true !important"
  if (
    clonedAttrs.style &&
    clonedAttrs.style.defaultBorder === "true !important"
  ) {
    clonedAttrs.style.borderColor = "";
    clonedAttrs.style.borderWidth = "";
    clonedAttrs.style.borderStyle = "";
    clonedAttrs.style.padding = "";
    clonedAttrs.style.margin = "";
    clonedAttrs.borderColor = "";
    clonedAttrs.borderWidth = "";
    clonedAttrs.borderStyle = "";
    clonedAttrs.padding = "";
    clonedAttrs.margin = "";
  }

  return clonedAttrs;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_unref(dynamicAttrs), { class: "VZ_TABLE_BUTTON" }), _toDisplayString(_unref(attrs).label), 17))
}
}

})